import { WorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { WorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { Button } from 'antd';
import React from 'react';
import { useDisclosure } from '@/hooks';

const WorkOrderQRCodeModal = React.lazy(() => import('./WorkOrderQRCodeModal'));

interface Props {
  guid: string;
  workOrder?: WorkOrder;
  complement?: WorkOrderComplement;
}

const WorkOrderQRCodeButton: React.FC<Props> = ({
  guid,
  workOrder,
  complement,
}) => {
  const [modalOpened, modalAction] = useDisclosure(false);

  const url = `${window.location.origin}/external/workOrderQRCode/${guid}`;

  return (
    <>
      <Button block onClick={modalAction.open}>
        Gerar QRCode
      </Button>

      {modalOpened && (
        <React.Suspense fallback={<></>}>
          <WorkOrderQRCodeModal
            open={modalOpened}
            onCancel={modalAction.close}
            url={url}
            workOrder={workOrder}
            complement={complement}
          />
        </React.Suspense>
      )}
    </>
  );
};

export default WorkOrderQRCodeButton;
